import { Box, FormControl, Input, FormLabel } from "@chakra-ui/react";
import WarningTextMessage from "../../../global/components/helper-components/components/WarningTextMessage";
import FormFieldCharactersRemaining from "./FormFieldCharactersRemaining";

export default function LaunchdeckFormInput({
  // Function
  name, placeholder, onChange, onBlur, value, label, onPressEnter, charLimit,
  // Error Handling
  errorMessage, errorLogic,
  // UIUX Options
  isRequired, isInvalid, cursor, autoFocus, type, isDisabled,
  // Styling options
  p, bg, fontSize, labelFontSize, fontWeight, noBorder
}) {


  return (
    <FormControl variant={"floating"} position='relative' w='100%' onKeyDown={onPressEnter && onPressEnter} isRequired={isRequired} isInvalid={isInvalid || errorLogic} >
      <Input
        name={name && name}
        autoFocus={autoFocus && autoFocus}
        onBlur={onBlur && onBlur}
        value={value && value}
        placeholder={placeholder || ""}
        onChange={onChange && onChange}
        // Styling
        fontSize={fontSize ? fontSize : '0.875em'}
        p={p ? p : '1.2em 1em'}
        mb='0.2em'
        w='100%'
        h='1.4em'
        fontWeight={fontWeight ? fontWeight : '400'}
        color={isDisabled ? "gray.600" : 'brandDark.500'}
        my='0.5em'
        borderRadius='0.25em'
        bg={isDisabled ? "gray.100" : bg || "white"}
        border={noBorder ? 'none' : '1px solid'}
        borderColor={"gray.300"}
        cursor={cursor && cursor}
        _invalid={{
          boxShadow: "none",
          borderColor: "brandPink.500",
        }}
        _focus={{
          boxShadow: "none !important",
          borderColor: "brand.500",
          outline: "none",
        }}
        // UX
        className='fade-in'
        type={type}
        isDisabled={isDisabled || false}
        transition="border 0.3s ease-in-out"
      />

      {/* It is important that the Label comes after the Control due to css selectors */}
      {placeholder ?
        <Box
          color='brandDark.500'
          top='0'
          left='0.5em'
          position='absolute'
          fontWeight='600'
          bg={!isDisabled && 'white'}
          zIndex='2'
          fontSize={'0.65em'}
          px='1em'
        >
          {label}
          {isRequired && <span style={{ color: '#FF2847' }}> *</span>}
        </Box>
        :
        <FormLabel fontSize={labelFontSize ? labelFontSize : '0.875em'} position="relative" top='3px' bg='none' color='gray.500'>
          {label}
        </FormLabel>
      }

      <Box textAlign='left'>
        {errorLogic ? <WarningTextMessage errorLogic={errorLogic} message={errorMessage} />
          : charLimit &&
          <FormFieldCharactersRemaining
            currentValue={value}
            characterLimit={charLimit}
          />
        }
      </Box>
    </FormControl>
  );

}